<div class="favorites">
  <div class="favorites__container">
    <h1 class="favorites__title" >my stuff</h1>
    <nav class="favorites-menu">
      <ul class="favorites-menu__list">
        <li
          *ngFor="let item of menu; index as index"
          class="favorites-menu__item"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: index === 0 }"
          (click)="setIndex(index)"
        >
          <a class="favorites-menu__link" [routerLink]="item.link">{{ item.name }}</a>
        </li>
      </ul>
    </nav>
    <div class="select-wrap">
      <select
        id="favorites-mobile-menu"
        class="select-wrap__select"
        (change)="changeSelectMenu($event)"
      >
        <ng-container *ngFor="let item of menu; index as index">
          <option
            [value]="item.id"
            [selected]="index === activeRoute"
            [ngValue]="item.id"
          >{{ item.name }}</option>
        </ng-container>
      </select>
    </div>
  </div>
</div>
